export enum EProjectContact {
  ch = 'PIRMIN JUNG Schweiz AG',
  de = 'PIRMIN JUNG Deutschland GmbH'
}
